


















  import {Component, Prop, Vue} from 'vue-property-decorator'
  import IconCustom from '@/components/lib/IconCustom.vue'
  import {ITag} from '@/entities'
  import {rangeLabel} from '@/lib'
import { isEqual } from 'lodash'

  @Component({
    components: {
      IconCustom
    }
  })
  export default class TravelTag extends Vue {
    @Prop() readonly data!: ITag
    @Prop({ default: false }) readonly large?: boolean

    get labelClass(): string {
      return this.large ? 'h-2' : 'strong sm tag-label';
    }

    get name(): string {
      return this.$t('filter.criteria.' + this.data.name) as string;
    }

    get iconSize(): string {
      return this.large ? 'extra' : 'lg';
    }

    get tooltip(): string {
      return this.large ? '' : (this.name + ': ' + this.labelWithContext(this.data.representation.label));
    }

    private labelWithContext(representation: string): string {
      switch (this.data.name) {
        case 'category':
          return this.$options.filters?.capitalize(this.$t(`category.${representation}`));
        case 'duration_days': {
          let conditionDays = 0;
          switch (true) {
            case (this.data.value > 1 && this.data.value <= 4): conditionDays = 2
            break;
            case (isEqual(this.data.value, 1)): conditionDays = 1;
            break;
          }

          return representation + ' ' + this.$tc('days', conditionDays);
        }
        case 'budget':
          return this.rangeTagLabel;
        case 'travel_format':
          switch(this.data.value) {
            case 'group': return (this.$tc('travel_format.group') as string);
            break;

            case 'single': return this.$tc('travel_format.single', 1) as string;
            break;

            case 'individual': return this.$tc('travel_format.individual', 1) as string;
            break;
          }
        default:
          return representation;
      }
    }

    get rangeTagLabel(): string {
      let range = this.data.value as any;
      let wrapper = this.data.name === 'budget' ? this.$storage.getters.wrapPriceLabel : undefined;
      return rangeLabel(range[0], range[1], wrapper, {
        minus: this.$options.filters?.capitalize(this.$t('lim-to')) + ' '
      });
    }

    get label(): string {
      if (this.data.type === "range") {
        return this.rangeTagLabel;
      } else {
        let representation: any = this.large ? this.data.representation : this.data.shortRepresentation;
        let postfix = (representation.remainder && !this.large) ? (' ' + this.$t('and-more', [representation.remainder])) : '';

        return this.labelWithContext(representation.label) + postfix;
      }
    }

  }
